// extracted by mini-css-extract-plugin
export var accreditations = "Accreditations--accreditations--55lTT";
export var accreditations__accreditation = "Accreditations--accreditations__accreditation--AIfT0";
export var tkMyriadProSemiCondensed = "Accreditations--tk-myriad-pro-semi-condensed--sxg2y";